import React from "react";
import {headerSortingClasses, sortCaret} from "../../../_metronic/_helpers";
import moment from "jalali-moment";
import TableLayout from "../../../_metronic/_partials/controls/table/TableLayout";

export default function BasketsTable({
                                         data,
                                         activePage,
                                     }) {

    // Table columns
    const columns = [
        {
            dataField: "priority",
            text: "شماره",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "id",
            text: "شناسه سبد",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "user_id",
            text: "شناسه کاربر",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "totalAmount",
            text: "قیمت",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "orderQuantity",
            text: "تعداد سفارش",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "status.name",
            text: "وضعیت",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "created_at",
            text: "تاریخ ایجاد",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: (date) => {
                if (date) {
                    const createdDate = moment(date, 'YYYY-M-D HH:mm:ss').format('jYYYY/jMM/jDD');
                    return <>{createdDate}</>;
                }

            },
        },
        // {
        //     dataField: "action",
        //     text: "عملیات",
        //     formatter: columnFormatters.ActionsColumnFormatter,
        //     formatExtraData: {
        //         openEditPage: handleEdit,
        //         dealerDeleteClick: productContext.handleDelete
        //     },
        //     classes: "text-right pr-0",
        //     headerClasses: "text-right pr-3",
        //     style: {
        //         minWidth: "100px",
        //     },
        // },
    ];

    return (
        <>
            <TableLayout activePage={activePage} columns={columns} data={data} />
        </>
    )
}